function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from 'react';

var _ref =
/*#__PURE__*/
React.createElement("linearGradient", {
  id: "tailwind_svg__a",
  x1: "-2.778%",
  x2: "100%",
  y1: "32%",
  y2: "67.556%"
}, React.createElement("stop", {
  offset: 0,
  stopColor: "#2298bd"
}), React.createElement("stop", {
  offset: 1,
  stopColor: "#0ed7b5"
}));

var _ref2 =
/*#__PURE__*/
React.createElement("path", {
  d: "M128 0C93.867 0 72.533 17.067 64 51.2 76.8 34.133 91.733 27.733 108.8 32c9.737 2.434 16.697 9.499 24.401 17.318C145.751 62.057 160.275 76.8 192 76.8c34.133 0 55.467-17.067 64-51.2-12.8 17.067-27.733 23.467-44.8 19.2-9.737-2.434-16.697-9.499-24.401-17.318C174.249 14.743 159.725 0 128 0zM64 76.8C29.867 76.8 8.533 93.867 0 128c12.8-17.067 27.733-23.467 44.8-19.2 9.737 2.434 16.697 9.499 24.401 17.318C81.751 138.857 96.275 153.6 128 153.6c34.133 0 55.467-17.067 64-51.2-12.8 17.067-27.733 23.467-44.8 19.2-9.737-2.434-16.697-9.499-24.401-17.318C110.249 91.543 95.725 76.8 64 76.8z",
  fill: "url(#tailwind_svg__a)"
});

var Tailwind = function Tailwind(props) {
  return React.createElement("svg", _extends({
    height: "1em",
    preserveAspectRatio: "xMidYMid",
    viewBox: "0 0 256 154",
    width: "1em"
  }, props), _ref, _ref2);
};

export default Tailwind;